/**
 * Auth API — binding to the shared createAuthApi(http) factory in
 * packages/common, bound to web's apiClient singleton.
 */

import { apiClient } from "@/lib/api/client";
import { createAuthApi } from "@speakai/common/src/auth/api";

export type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  SSOLoginRequest,
  SSOType,
  ForgotPasswordRequest,
  VerifyOTPRequest,
  RefreshTokenRequest,
  SessionResponse,
  ChangePasswordRequest,
  UserProfile,
  DesktopHandoffResponse,
} from "@speakai/common/src/auth/types";

export const {
  login,
  register,
  ssoLogin,
  forgotPassword,
  verifyOTP,
  resendOTP,
  verifyEmail,
  refreshToken,
  logout,
  getSession,
  changePassword,
  getUserByToken,
  resendInviteEmail,
  getTeamInvite,
  claimTeamInvite,
  generate2FA,
  enable2FA,
  disable2FA,
  get2FADevices,
  revoke2FADevice,
  verify2FA,
  registerLeadUser,
  verifyToken,
  updateUserByToken,
  getInviteMeta,
  claimInvite,
  verifyInviteOtp,
  createDesktopHandoffCode,
} = createAuthApi(apiClient);
